import { Link, LinkProps } from "@remix-run/react";

import data from "~/data";
import { cn } from "~/lib/utils";

function cleanPhoneNumber(phone: string): string {
    return phone.replace(/[\s\-().]/g, "");
}

export function Header({ className, to }: { className?: string; to?: LinkProps["to"] }) {
    const telLink = data?.tollFree ? cleanPhoneNumber(data.tollFree) : "";
    return (
        <header className={cn("flex items-center bg-black-400 py-4", className)}>
            <div className="page px-page flex items-center justify-between">
                <Logo to={to} />
                {data?.tollFree && <a href={`tel:${telLink}`} className="text-white hover:underline"><span>Contact Us: </span>{data.tollFree}</a>}
            </div>
        </header>
    );
}

export function Footer({ className, to }: { className?: string; to?: LinkProps["to"] }) {
    return (
        <footer className={cn("bg-[#282828] text-white", className)}>
            <div className="page py-6 border-white border-b border-opacity-40 flex items-center justify-center">
                <Logo to={to} />
            </div>
            <div className="page px-page py-4 text-opacity-60 text-sm text-white">
                <p>Copyright &copy; 2025</p>
            </div>
        </footer>
    );
}

function Logo({ to }: { to?: LinkProps["to"] }) {
    const image = <img alt={data.logo.alt} className="h-full max-h-16" src={data.logo.src} />;
    if (to) {
        return (
            <Link to={to} className="w-auto">
                {image}
            </Link>
        );
    } else {
        return <div className="w-auto h-full">{image}</div>;
    }
}
